import { Component, OnInit, Input } from '@angular/core';
import { CustomFields } from 'src/app/models/custom-fields';
import { CustomFieldType } from 'src/app/alv-enums';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'custom-field',
  templateUrl: './custom-field.component.html',
  styleUrls: ['./custom-field.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class CustomFieldComponent implements OnInit {

  constructor() { }
  maxLength:number;
  @Input() index:number;
  @Input() customField:CustomFields;
  @Input() readOnly : boolean;
  value:any;
  value1:any;
  formSubmitted : boolean = false;
  customFieldEnum = CustomFieldType; // this is to allow CustomFieldType enum to be used in html
  ngOnInit() {
    this.value = this.customField;
  }

  mapZipAndStateFields() : string{
    if(this.customField.fieldName == 'Zip Code'){
      return 'Zip/Postal Code';
    } else if(this.customField.fieldName == 'State'){
      return 'State/Province';
    }
    return this.customField.fieldName;
  }

}
